import React from 'react';
import { Link, Typography } from '@material-ui/core';
import i18next from 'i18next';
import { Button, Color } from '@signaturit/react-components-library';
import { AcceptedExtraData } from '@signaturit/data-tracker-client';

import { UserAlertNotificationsFlowStyles } from '../useUserAlertNotificationsFlow.styles';
import { SETTINGS_UPGRADE_URL } from '../../../config/routes';
import { DataTrackerEvents } from '../../../main/dataTracker/DataTrackerEvents';
import { sendDataTrackerEventHandler } from '../../../main/dataTracker/DataTrackerHelper';

const sendDataTracker = () => {
    sendDataTrackerEventHandler(DataTrackerEvents.clickDemoBarButton, {}, [AcceptedExtraData.limits]);
};

export const demoAlertNotificationTemplate = (classes: UserAlertNotificationsFlowStyles) => (
    <div data-signa="demo-alert-notification-content" className={`${classes.content} ${classes.typeError}`}>
        <Typography variant="body2">{i18next.t('default.alert_notifications.not_active_account')}</Typography>
        <Link data-signa="alert-notification-reactivate-button" href={SETTINGS_UPGRADE_URL}>
            <div className={classes.button}>
                <Button color={Color.error} fullWidth={true} onClick={sendDataTracker}>
                    {i18next.t('default.alert_notifications.reactivate')}
                </Button>
            </div>
        </Link>
    </div>
);
